import { DAILY_STATS_PATH } from '../../constants'
import AbstractService from '../../services/AbstractService'
import { PagePagination, ServerResponse } from '../../types'
import { Trade } from '../TradingLog/types'

import { DailyStatsData } from './types'

class DailyStatsServiceClass extends AbstractService {
  getTrades = (
    data: Pick<
      PagePagination<Trade>,
      'page' | 'perPage' | 'columns' | 'period' | 'account' | 'fromCalendar'
    >,
  ) => this.request<ServerResponse<DailyStatsData>>(DAILY_STATS_PATH, 'post', true, data)
}

export const DailyStatsService = new DailyStatsServiceClass()
